import SingleSelectComponent from "../single-select/single-select.component";

/**
 * YearPickerComponent
 * 
 * This is a year picker component based on `SingleSelectComponent`.
 * 
 * @author CV Leong 
 */
export default function YearPickerComponent() {

  const DEFAULT_MAX = new Date().getFullYear() + 100;
  const DEFAULT_MIN = new Date().getFullYear() - 100;

  return {
    view: ({ attrs: {
      max = DEFAULT_MAX,
      min = DEFAULT_MIN,
      ...otherAttrs
    } }) => {
      return [
        m(SingleSelectComponent, {
          allowEmpty: false,
          keyOnly: true,
          ...otherAttrs,
          // prevent override
          items: renderYearOptions(min, max),
        }),
      ]
    }
  }
}

/**
 * Generates an option list for `YearPickerComponent`.
 * @param {Number} min - The minimum year allowed.
 * @param {Number} max - The maximum year allowed.
 * @returns Returns an array of year options. 
 */
const renderYearOptions = (min, max) => {

  if (isNaN(min) || isNaN(max)) {
    throw 'min/max is not number';
  }

  min = Number(min);
  max = Number(max);

  const options = []
  for (let i = max; i >= min; i--) {
    options.push({ code: i.toString(), name: i.toString() });
  }

  return options;
}
